/**
 * 该文件用于环境配置
 */
import {request} from "./request.js"
/*分享 start*/
const share=new class{
      constructor(){
        this.request=request
      }
      getShareInfo(data){
        var title = data.shareTile;
        var link = window.location.href;
        var desc = data.shareCopywriting;
        var imgUrl = data.shareImg;
        console.log(title,link,desc,imgUrl,"分享文案")
        wx.onMenuShareTimeline({
            title: title, // 分享标题
            link: link, // 分享链接
            imgUrl: imgUrl, // 分享图标
            success: function () { 
              console.log("Timeline");
              data.callback();
                // 用户确认分享后执行的回调函数
            },
            cancel: function () { 
                // 用户取消分享后执行的回调函数
            }
        });
        wx.onMenuShareAppMessage({
            title: title, // 分享标题
            desc: desc, // 分享描述
            link: link, // 分享链接
            imgUrl: imgUrl, // 分享图标
            success: function () { 
              console.log("AppMessage");
              data.callback();
            },
            cancel: function () { 
            }
        });
        wx.onMenuShareQQ({
            title: title, // 分享标题
            desc: desc, // 分享描述
            link: link, // 分享链接
            imgUrl: imgUrl, // 分享图标
            success: function () { 
            },
            cancel: function () { 
            }
        });
        
        wx.onMenuShareWeibo({
            title: title, // 分享标题
            desc: desc, // 分享描述
            link: link, // 分享链接
            imgUrl: imgUrl, // 分享图标
            success: function () { 
            },
            cancel: function () { 
            }
        });
        
        wx.onMenuShareQZone({
            title: title, // 分享标题
            desc: desc, // 分享描述
            link: link, // 分享链接
            imgUrl: imgUrl, // 分享图标
            success: function () { 
            },
            cancel: function () { 
            }
        });
      }
      getShareInfo(option){
        // console.log(option.request.post,"======option")

        let _this = this;
        this.request.post({
          url:option.url,
          baseUrl:option.baseUrl,
          data:option.data,
          needSign:true,
          success:(res)=>{
            //console.log(res.data.result.appId,res.data.result.nonceStr,7878)
             if(res.data.result){
              //console.log("进入if result",wx,"wx")
                wx.config({
                  debug: false,
                  appId: res.data.result.appId, // 必填，公众号的唯一标识
                  timestamp: res.data.result.timestamp, // 必填，生成签名的时间戳
                  nonceStr: res.data.result.nonceStr, // 必填，生成签名的随机串
                  signature: res.data.result.signature,// 必填，签名，见附录1
                  jsApiList: ["onMenuShareTimeline","onMenuShareAppMessage","onMenuShareQQ","onMenuShareWeibo","onMenuShareQZone"]
                });
              }else{
                console.log("分享参数返回结构错误");
                return;
              };
              wx.ready(function(){
                _this.getShareInfo(option.shareData)
              });
          },
          error:(res)=>{
            //console.log(res,78956);
          }
        });
      }
}

/*分享 end*/
//  (url,baseUrl,data)
export {
  share
};



// WEBPACK FOOTER //
// ./static/js/lib/share.js